import { render, staticRenderFns } from "./MailingsMessageDetailsRecipients.vue?vue&type=template&id=7360d50f&scoped=true&"
import script from "./MailingsMessageDetailsRecipients.vue?vue&type=script&lang=ts&"
export * from "./MailingsMessageDetailsRecipients.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7360d50f",
  null
  
)

export default component.exports